import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  InputGroup,
  FormInput,
  Modal,
  ModalBody,
  ModalHeader,
} from "shards-react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import { Table } from "react-bootstrap";
import axios from "axios";
import { Cloud_API_URL } from "../../../utils/constants";
import moment from "moment";
import "./tab.css";

const TrainingResult = ({ userdata }) => {
  const programId =
    userdata && userdata.Programs && userdata.Programs.id
      ? userdata.Programs.id
      : "";
  const [userProgram, setUserProgram] = useState("");
  const [sessionsDoneLog, setSessionsDoneLog] = useState([]);
  const [search_text, setSearch_text] = useState("Session_");
  const [isDataVisible, setIsDataVisible] = useState(false);
  const [trainingData, setTrainingData] = useState([]);
  const [sqlTrainingData, setSqlTrainingData] = useState([]);
  const [sqlDataLoading, setSqlDataLoading] = useState(false);
  const [rawSqlData, setRawSqlData] = useState([]);
  const [isFirebaseModalVisible, setIsFirebaseModalVisible] = useState(false);
  const [sqlSearchText, setSqlSearchText] = useState("");

  useEffect(() => {
    getUserPrograms();
    fetchSqlTrainingData(userdata && userdata.uuid);
  }, []);
  const toggleFirebaseModal = () =>
    setIsFirebaseModalVisible(!isFirebaseModalVisible);
  const toggleSqlModal = () => setIsDataVisible(!isDataVisible);
  const handleSqlSearch = (e) => {
    setSqlSearchText(e.target.value);
  };

  const getUserPrograms = async () => {
    if (programId) {
      const docRef = doc(db, "UserProgram", programId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data().SessionsDoneLog || [];
        setSessionsDoneLog(data.reverse());

        const programData = docSnap.data().Program;
        const programReference =
          programData &&
          programData.length > 0 &&
          programData[0].ProgramReference;
        if (programReference && programReference.id) {
          getProgram(programReference.id);
        }
      }
    }
  };

  const getProgram = async (id) => {
    const docRef = doc(db, "Programs", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      setUserProgram(docSnap.data());
    }
  };

  // Helper function to get unique sessions with earliest start time and total session duration
  const getUniqueSessionsWithEarliestStartTime = (data) => {
    const sessionMap = new Map();

    data.forEach((item) => {
      const sessionNumber = item.session_number;
      const sessionDuration = parseFloat(item.session_duration || "0");
      const startTime = item.start_time || null;
      const sessionType = item.type || "N/A";

      const speed = parseFloat(item.speed || "0");
      const pendulumLength = parseFloat(item.pendulumLength || "0");
      const offset = parseFloat(item.offset || "0");
      const oscillationTime = parseFloat(item.oscillationTime || "0");

      // Check if the session number already exists in the map
      if (sessionMap.has(sessionNumber)) {
        const existingSession = sessionMap.get(sessionNumber);

        // Update the total duration
        const totalDuration =
          existingSession.session_duration + sessionDuration;

        // Determine the earliest start time
        const earliestStartTime =
          startTime && moment(startTime).isBefore(existingSession.start_time)
            ? startTime
            : existingSession.start_time;

        // Calculate the new session saved time
        const savedTime = earliestStartTime
          ? moment(earliestStartTime)
              .add(totalDuration, "seconds")
              .toISOString()
          : null;

        const newSpeed = (existingSession.speed + speed) / 2;
        const newPendulumLength =
          (existingSession.pendulumLength + pendulumLength) / 2;
        const newOffset = (existingSession.offset + offset) / 2;
        const newOscillationTime =
          (existingSession.oscillationTime + oscillationTime) / 2;

        // Update the session data in the map
        sessionMap.set(sessionNumber, {
          session_number: sessionNumber,
          session_name: `Session ${sessionNumber}`,
          session_duration: totalDuration,
          start_time: earliestStartTime,
          saved_time: savedTime,
          type: sessionType,
          speed: newSpeed,
          pendulumLength: newPendulumLength,
          offset: newOffset,
          oscillationTime: newOscillationTime,
        });
      } else {
        // If the session number is not in the map, add it
        const savedTime = startTime
          ? moment(startTime).add(sessionDuration, "seconds").toISOString()
          : null;

        sessionMap.set(sessionNumber, {
          session_number: sessionNumber,
          session_name: `Session ${sessionNumber}`,
          session_duration: sessionDuration,
          start_time: startTime,
          saved_time: savedTime,
          type: sessionType,
          speed: speed,
          pendulumLength: pendulumLength,
          offset: offset,
          oscillationTime: oscillationTime,
        });
      }
    });

    // Convert the map to an array of unique sessions
    const uniqueSessions = Array.from(sessionMap.values());

    return uniqueSessions;
  };

  // Fetch SQL Training Data
  const fetchSqlTrainingData = async (userId) => {
    setSqlDataLoading(true);
    try {
      const response = await axios.get(
        `${Cloud_API_URL}/user/${userId}/training_session_data`
      );
      const rawData = response.data || [];
      const uniqueSessions = getUniqueSessionsWithEarliestStartTime(rawData);
      setRawSqlData(rawData); // Save raw data
      setSqlTrainingData(uniqueSessions);
    } catch (error) {
      console.error("Error fetching SQL training data:", error);
    }
    setSqlDataLoading(false);
  };

  // Search Handler
  const Search = (e) => {
    setSearch_text(e.target.value);
  };

  const viewTrainingData = (item, isSqlData = false) => {
    if (isSqlData) {
      // For SQL data, filter rawSqlData for the selected session_number
      const filteredData = rawSqlData.filter(
        (entry) => entry.session_number === item.session_number
      );
      setTrainingData(
        filteredData.map((log) => ({
          ...log,
          type: log.type ? log.type : "N/A",
          streamingSource: log.streamingSource ? log.streamingSource : "N/A",
        }))
      );
    } else {
      // For Firebase data, use the MultiSessionlog if available
      const multiSessionData = Array.isArray(item.MultiSessionlog)
        ? item.MultiSessionlog
        : [];
      const sessionType = item.type ? item.type : "N/A";
      const streamingSource =
        item.TrainedOn && item.TrainedOn.streamingSource
          ? item.TrainedOn.streamingSource
          : "N/A";

      setTrainingData(
        multiSessionData.map((log) => ({
          ...log,
          type: sessionType,
          streamingSource: streamingSource,
        }))
      );
    }
    trainingDataModal();
  };
  const viewFirebaseTrainingData = (item) => {
    const multiSessionData = Array.isArray(item.MultiSessionlog)
      ? item.MultiSessionlog
      : [];
    setTrainingData(multiSessionData);
    setIsDataVisible(false);
    setIsFirebaseModalVisible(true);
  };
  // Toggle Modal Visibility
  const trainingDataModal = () => {
    setIsFirebaseModalVisible(false);
    setIsDataVisible(!isDataVisible);
  };

  // Render Table
  const renderTable = (data, title) => (
    <Card small className="mb-4">
      <CardHeader className="border-bottom">
        <h6 className="m-0">{title}</h6>
        <FormGroup>
          <InputGroup>
            <FormInput
              placeholder="Search"
              value={search_text}
              onChange={Search}
            />
          </InputGroup>
        </FormGroup>
      </CardHeader>
      <CardBody className="p-0 pb-3">
        <Table responsive striped bordered hover size="md">
          <thead className="bg-light">
            <tr>
              <th>Session Name</th>
              <th>Session Duration</th>
              <th>Session Started At</th>
              <th>Session End At</th>
            </tr>
          </thead>
          <tbody>
            {data && data.length > 0 ? (
              data
                .filter(
                  (item) =>
                    search_text === "" ||
                    (item.SessionName &&
                      item.SessionName.toLowerCase().includes(
                        search_text.toLowerCase()
                      ))
                )
                .map((item, index) => {
                  // Calculate session duration from MultiSessionlog entries instead of SessionDuration
                  const multiSessionData = Array.isArray(item.MultiSessionlog)
                    ? item.MultiSessionlog
                    : [];
                  const duration = multiSessionData.reduce(
                    (total, log) => total + parseFloat(log.duration || 0),
                    0
                  );
                  const formattedDuration = moment
                    .utc(duration * 1000)
                    .format("HH:mm:ss");

                  // Calculate session started time
                  const sessionStartedAt =
                    item.SessionStartedAt &&
                    moment(item.SessionStartedAt.toDate()).isValid()
                      ? moment(item.SessionStartedAt.toDate()).format("lll")
                      : "N/A";

                  // Calculate session end time
                  const sessionEndAt =
                    item.SessionStartedAt &&
                    moment(item.SessionStartedAt.toDate()).isValid()
                      ? moment(item.SessionStartedAt.toDate())
                          .add(duration, "seconds")
                          .format("lll")
                      : "N/A";

                  const sessionName =
                    item.SessionName || `Session ${item.session_number}`;

                  return (
                    <tr
                      key={index}
                      onClick={() => viewFirebaseTrainingData(item)}
                      style={{ cursor: "pointer" }}
                    >
                      <td>{sessionName}</td>
                      <td>{formattedDuration}</td>
                      <td>{sessionStartedAt}</td>
                      <td>{sessionEndAt}</td>
                    </tr>
                  );
                })
            ) : (
              <tr>
                <td colSpan="4">No Data Available</td>
              </tr>
            )}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );

  const renderSqlTable = (data) => (
    <Card small className="mb-4">
      <CardHeader className="border-bottom">
        <h6 className="m-0">SQL API Data</h6>
        <FormGroup>
          <InputGroup>
            <FormInput
              placeholder="Search"
              value={sqlSearchText}
              onChange={handleSqlSearch}
            />
          </InputGroup>
        </FormGroup>
      </CardHeader>
      <CardBody className="p-0 pb-3">
        <Table responsive striped bordered hover size="md">
          <thead className="bg-light">
            <tr>
              <th>Session Name</th>
              <th>Session Duration</th>
              <th>Session Started At</th>
              <th>Session End At</th>
            </tr>
          </thead>
          <tbody>
            {data
              .filter(
                (item) =>
                  sqlSearchText === "" ||
                  (item.session_name &&
                    item.session_name
                      .toLowerCase()
                      .includes(sqlSearchText.toLowerCase()))
              )
              .map((item, index) => {
                const formattedDuration = moment
                  .utc(item.session_duration * 1000)
                  .format("HH:mm:ss");

                const formattedStartTime = item.start_time
                  ? moment(item.start_time).format("lll")
                  : "N/A";

                const formattedSavedTime = item.saved_time
                  ? moment(item.saved_time).format("lll")
                  : "N/A";

                return (
                  <tr
                    key={index}
                    onClick={() => viewTrainingData(item, true)}
                    style={{ cursor: "pointer" }}
                  >
                    <td>{item.session_name}</td>
                    <td>{formattedDuration}</td>
                    <td>{formattedStartTime}</td>
                    <td>{formattedSavedTime}</td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <Row>
        <Col md="6">
          <h5>Firebase Training Data</h5>
          {sessionsDoneLog.length > 0
            ? renderTable(sessionsDoneLog, "Firebase Data")
            : "No Data Available"}
        </Col>
        <Col md="6">
          <h5>SQL API Training Data</h5>
          {sqlDataLoading ? (
            <div>Loading...</div>
          ) : (
            renderSqlTable(sqlTrainingData)
          )}
        </Col>
      </Row>

      <Modal open={isDataVisible} toggle={trainingDataModal}>
        <ModalHeader>Training Data Details</ModalHeader>
        <ModalBody>
          {trainingData.length > 0
            ? trainingData.map((tData, index) => {
                const duration = parseFloat(
                  tData.duration ? tData.duration : tData.session_duration || 0
                );
                const formattedDuration = moment
                  .utc(duration * 1000)
                  .format("HH:mm:ss");

                const startTime = tData.startTime
                  ? tData.startTime
                  : tData.start_time;
                const formattedStartTime =
                  startTime && moment(startTime).isValid()
                    ? moment(startTime).format("lll")
                    : "N/A";

                // Calculate session end time
                const sessionEndTime =
                  startTime && moment(startTime).isValid()
                    ? moment(startTime).add(duration, "seconds").format("lll")
                    : "N/A";

                const streamingSource = tData.streamingSource
                  ? tData.streamingSource
                  : "N/A";

                const type = tData.type ? tData.type : "N/A";
                const offset = tData && tData.offset ? tData.offset : "N/A";
                const oscillationTime =
                  tData && tData.oscillationTime
                    ? tData.oscillationTime
                    : "N/A";
                const pendulumLength =
                  tData && tData.pendlumLength ? tData.pendlumLength : "N/A";
                const speed = tData && tData.speed ? tData.speed : "N/A";

                return (
                  <div
                    key={index}
                    className="mb-3"
                    style={{ borderBottom: "1px solid black" }}
                  >
                    <p>Duration: {formattedDuration}</p>
                    <p>Type: {type}</p>
                    <p>Session Started At: {formattedStartTime}</p>
                    <p>Session Ended At: {sessionEndTime}</p>
                    <p>Streaming Source: {streamingSource}</p>
                    <div className="mt-2">
                      <p>Offset: {offset}</p>
                      <p>Oscillation Time: {oscillationTime}</p>
                      <p>Pendulum Length: {pendulumLength}</p>
                      <p>Speed: {speed}</p>
                    </div>
                  </div>
                );
              })
            : "No Data Available"}
        </ModalBody>
      </Modal>
      {isFirebaseModalVisible && (
        <Modal open={isFirebaseModalVisible} toggle={toggleFirebaseModal}>
          <ModalHeader>Trainig Data</ModalHeader>
          <ModalBody>
            {trainingData && trainingData.length > 0 ? (
              <>
                {trainingData.map((tData, index) => {
                  {
                  }
                  return (
                    <div
                      key={index}
                      className="mb-4"
                      style={{ borderBottom: "1px solid black" }}
                    >
                      <p className="mb-0">
                        Duration:{" "}
                        {tData.duration &&
                          moment("2015-01-01")
                            .startOf("day")
                            .seconds(tData.duration)
                            .format("HH:mm:ss")}
                      </p>
                      <p className="mb-0">
                        Session Started At:{" "}
                        {tData.startTime &&
                          moment(tData.startTime.toDate().toString()).format(
                            "lll"
                          )}
                      </p>
                      <p className="mb-0">
                        Session Ended At:{" "}
                        {tData.endTime &&
                          moment(tData.endTime.toDate().toString()).format(
                            "lll"
                          )}
                      </p>
                      <div className="mt-2">
                        <p className="mb-2">Details:</p>
                        <span className="d-block">
                          OffSet: {tData.TrainedOn.offset}
                        </span>
                        <span className="d-block">
                          Oscillation Time: {tData.TrainedOn.oscillationTime}
                        </span>
                        <span className="d-block">
                          Pendlum Length: {tData.TrainedOn.pendlumLength}
                        </span>
                        <span className="d-block">
                          Speed: {tData.TrainedOn.speed}
                        </span>
                        <span className="d-block">
                          Type: {tData.TrainedOn.type}
                        </span>
                        {tData.TrainedOn.streamingSource && (
                          <span className="d-block mb-3">
                            Streaming Source: {tData.TrainedOn.streamingSource}
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              "No Data available"
            )}
          </ModalBody>
        </Modal>
      )}
    </Container>
  );
};

export default TrainingResult;
